import React, { PropsWithChildren } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

type DfnProps = PropsWithChildren<{
  modifier?: Modifier<'bold'>;
}>;

export function Dfn({ children, modifier }: DfnProps) {
  return (
    <dfn className={bem('dfn', modifier)}>
      {children}
    </dfn>
  );
}
